import axios from 'axios';
import * as utils from '../../utils/Utils';
import { getNonGwApiRoot } from '../../constants/ParamountReactConstants';

export function fetchLoadSheets(page = 1, keywords?: string) {
  const urlParams = utils.createURL([
    { name: 'page', values: page },
    { name: 'limit', values: utils.getPageLimit() },
    { name: 'keywords', values: utils.stringToArray(keywords) },
  ]);

  return {
    type: 'FETCH_LOAD_SHEETS',
    meta: { page },
    payload: axios.get(`${getNonGwApiRoot()}/distribution/load_sheets${urlParams}`),
  };
}

export function fetchLoadSheetTemplate(id: number) {
  const urlParams = utils.createURL([{ name: 'load_sheet_id', values: id }]);

  return {
    type: 'FETCH_LOAD_SHEET_TEMPLATE',
    payload: axios.get(`${getNonGwApiRoot()}/distribution/load_sheets/load_sheet${urlParams}`),
  };
}

export function fetchLoadSheetPreview(identifier: string | number, isId = false) {
  const urlParams = [
    { name: 'type', values: 'excel' },
    isId
      ? { name: 'load_sheet_id', values: identifier.toString() }
      : { name: 'load_sheet_name', values: identifier.toString() },
  ];
  const params = utils.createURL(urlParams);
  return {
    type: 'FETCH_LOAD_SHEET_PREVIEW',
    payload: axios({
      method: 'post',
      url: `${getNonGwApiRoot()}/distribution/load_sheets/preview${params}`,
      responseType: 'arraybuffer',
    }),
  };
}

export function fetchAccountEBPTemplates() {
  return {
    type: 'FETCH_ACCOUNT_EBP_TEMPLATES',
    payload: axios.get(
      `${getNonGwApiRoot()}/distribution/load_sheets/account_full_export_templates`
    ),
  };
}

export function fetchLoadSheetPreviewEBPColumns(full_export_template_id: number) {
  const params = utils.createURL([
    { name: 'receiver_full_export_template_id', values: full_export_template_id },
  ]);
  return {
    type: 'FETCH_LOAD_SHEET_PREVIEW_EBP_COLUMNS',
    payload: axios.post(
      `${getNonGwApiRoot()}/distribution/load_sheets/ebp_preview_columns${params}`
    ),
  };
}

export function setLoadSheetPreviewData(previewData: any) {
  return {
    type: 'SET_LOAD_SHEET_PREVIEW_DATA',
    payload: previewData,
  };
}

export function clearLoadSheetPreviewData() {
  return {
    type: 'CLEAR_LOAD_SHEET_PREVIEW_DATA',
  };
}

export function clearSelectedTemplate() {
  return {
    type: 'CLEAR_SELECTED_TEMPLATE',
  };
}
